module.exports = __webpack_public_path__ + "img/53.5f14b5f0.png";